import { inject, provide } from 'vue'
import { createDeepAChat } from '@/pocs/chat/composables/chat'
import type { InjectionKey } from 'vue'

type DeepAChat = ReturnType<typeof createDeepAChat>

const KEY = Symbol('ContextDeepAChat') as InjectionKey<DeepAChat>

export function createContextDeepAChat() {
  const chat = createDeepAChat()
  provide(KEY, chat)
  return chat
}

export function useContextDeepAChat() {
  const chat = inject(KEY)
  if (!chat) {
    throw new Error(
      'Please call `createContextDeepAChat` on the appropriate parent component',
    )
  }
  return chat
}

export function useContextDeepAChatOptional() {
  return inject(KEY, undefined)
}
